module.exports = __webpack_public_path__ + "static/media/music.7f4d7989.svg";